import React, { FC, ReactElement } from 'react';
import {useSelector} from 'react-redux';
import {internalizationState, ParamsDto} from '../../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';

interface Props {
  speakers: any[];
  allowTargetBeforeStart?: boolean;
  questionModalhandler?: CallableFunction;
  viewParams?: any;
}

const CardsView: FC<Props> = ({ speakers, viewParams }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);
  const backgroundParam = viewParams.find((param: ParamsDto) => param.key === 'speakerCardColor') || '';
  
  return (
    <div className="speakers-cards">
      { 
        speakers &&
        speakers.length &&
        speakers.map((speaker: any, index: number) => (
          <div
            key={index}
            className="speakers-cards__item"
            style={{backgroundColor: backgroundParam.value}}
          >
            <div className="speakers-cards__item__image">
              <img src={speaker.photo} alt={ localeFieldResolver(speaker, 'fullnameRu', activeLangState) } />
            </div>
            <p className="speakers-cards__item__name">
              { localeFieldResolver(speaker, 'fullnameRu', activeLangState) }
            </p>
            <p className="speakers-cards__item__description user-fs-text__sm">
              { localeFieldResolver(speaker, 'descriptionRu', activeLangState) }
            </p>
          </div>
        ))
      }
    </div>
  )
}

export default CardsView;
